if (!customElements.get('theme-tab')) {
    customElements.define('theme-tab', class ThemeTab extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab) => {
          tab.addEventListener('keydown', (e) => this.onKeydown(e, tab));
        });
      }

      onKeydown(event, tab) {
        const lastIndex = this.tabs.length - 1;
        const idx = this.tabs.indexOf(tab);
        let nextIndex = -1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = idx === lastIndex ? 0 : idx + 1;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = idx === 0 ? lastIndex : idx - 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = lastIndex;
        }
        if (nextIndex >= 0) {
          event.preventDefault();
          this.tabs[nextIndex].focus();
          this.tabs[nextIndex].click();
        }
      }

      open(button, tab) {
        const _target = button.closest('li, .btn_link');

        if (_target.classList.contains('active')) return;

        const _active = this.querySelector(`li.active, .btn_link.active`);
        const _activeTab = this.querySelector(`.tab__content-item.active`);
        const _targetTab = this.querySelector(`[data-tab-id="${tab}"]`);

        if (_active) _active.classList.remove('active');
        if (_activeTab) _activeTab.classList.remove('active');
        _target.classList.add('active');
        if (_targetTab) _targetTab.classList.add('active');

        if (this.tabs && this.tabs.length) {
          this.tabs.forEach((t) => {
            const isActive = t === button;
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
            t.setAttribute('tabindex', isActive ? '0' : '-1');
          });
        }
      }
    });
  }
